import { addComponentEventHandlers } from "../../../assets/javascripts/lib/component_event_handler";

addComponentEventHandlers('meta[name="flash-messages"]', (element) => {
  try {
    const payload = element.getAttribute("content");
    const detail = JSON.parse(payload);
    document.body.dispatchEvent(new CustomEvent("showFlash", { detail }));
  } catch {
    // 解析に失敗した場合は何もしない（従来の Flash 表示が残っていればそちらが利用される）
  } finally {
    element.remove();
  }
});
